export default __webpack_public_path__ + "static/media/pentagons-no-1.c8cc49f5.ogg";